module.exports = __webpack_public_path__ + "img/product-price-distribution.5ec53f48.jpg";